import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDelete({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M9.18 12.38h.64c.18 0 .32-.15.32-.33v-5.9a.32.32 0 00-.32-.34h-.64a.32.32 0 00-.32.33v5.9c0 .19.14.34.32.34zm4.4-9.2h-2.22l-.9-1.54C10.21 1.24 9.8 1 9.34 1h-2.7c-.45 0-.87.24-1.1.64l-.91 1.55h-2.2c-.24 0-.43.2-.43.44v.43c0 .24.2.44.43.44h.43v9.19c0 .72.57 1.31 1.28 1.31h7.72a1.3 1.3 0 001.28-1.31V4.5h.43c.24 0 .43-.2.43-.44v-.43c0-.25-.2-.44-.43-.44zM6.6 2.4a.16.16 0 01.14-.08h2.52c.06 0 .1.03.14.08l.46.8H6.14l.46-.8zm5.26 11.3H4.14V4.5h7.72v9.19zm-5.68-1.31h.64c.18 0 .32-.15.32-.33v-5.9a.32.32 0 00-.32-.34h-.64a.32.32 0 00-.32.33v5.9c0 .19.14.34.32.34z" />
    </svg>
  );
}

SvgBasicDelete.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDelete.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicDelete svgRef={ref} {...props} />);
export default ForwardRef;
